<template>
  <div class="hvh-card--rounded v-sheet theme--light">
    <div class="hvh-flex space-between " style="flex-direction: column;">
      <div>
        <h2 class="text-xs-center" v-if="text">{{ text }}</h2>
      </div>
      <div class="hvh-flex mb-4" v-if="legendItems">
        <div class="hvh-flex-center ml-3" v-for="option in legendItems" :key="option.text">
          <dt class="mb-2" style="width: 12px; height: 12px">
            <svg viewBox="0 0 12 12">
              <path :fill="option.color" :d="option.path" />
            </svg>
          </dt>
          <label class="ml-2">{{ option.text }}</label>
        </div>
      </div>
    </div>
    <div class="hvh-relative">
      <HvhChart :visualization="visualization" :options="mergedOptions" :isEditMode="true" :height="height" @item-clicked="$emit('checked-changed', $event)" @dataCreated="$emit('data-created', $event)" @wheel="scroll" />
      <HvhVerticalScrollBar class="scroll-bar" :total="(data[0] || []).length" :displayed="displayedBarChartData" v-model="scrollBarValue" v-if="(data[0] || []).length > displayedBarChartData" />
      <Loader v-if="isFiltering" />
    </div>
  </div>
</template>
  
  
<script>
import HvhChart from '../../charts/HvhChart.vue';
import HvhVerticalScrollBar from '../../common/scrollBar/HvhVerticalScrollBar.vue';
import { merge } from 'lodash';
import { Debouncer, hashCode } from '../../../libraries/common';

export default {
  components: { HvhVerticalScrollBar, HvhChart },
  props: ['data', 'filterObject', 'text', 'isChecked', 'nameField', 'valueField', 'options', 'isFiltering', 'height', 'legendItems'],
  data() {
    return {
      displayedBarChartData: 10,
      scrollBarValue: 0,
      mergedOptions: merge({
        grid: {
          bottom: '0%',
          containLabel: true,
          left: '20px',
          right: '30px',
          top: '0%'
        },
        yAxis: {
          axisLabel: {
            inside: true,
          },
          axisTick: {
            show: false
          },
        },
      }, (this.options || {})),
      debouncer: new Debouncer(2000),
    };
  },
  methods: {
    scroll(event) {
      var oldValue = this.scrollBarValue;
      this.scrollBarValue += event.wheelDeltaY < 0 ? 1 : -1;
      this.scrollBarValue = Math.max(0, Math.min(this.scrollBarValue, (this.data[0] || []).length - this.displayedBarChartData));
      if (Math.abs(oldValue - this.scrollBarValue) > 0) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
  },
  computed: {
    visualization() {
      var dataLength = Math.min((this.data[0] || []).length, this.displayedBarChartData);
      return {
        visualization_type: 'horizontalbarchart',
        name_field: this.nameField || 'diagnosis',
        value_field: this.valueField || 'totalpatients',
        data: this.data.map(arr => arr.filter((_, ind) => ind >= this.scrollBarValue && ind < this.scrollBarValue + dataLength)
          .map(f => ({ ...f, unchecked: this.isChecked && arr.find(f => this.isChecked(f)) && !this.isChecked(f) }))),
        stacked: true,
      };
    },
    filterHash() {
      return hashCode(this.filterObject || {});
    },
  },
  watch: {
    filterHash() {
      this.debouncer.clear().push(() => this.$emit('refresh-data', this.filterObject));
    },
  },
  mounted() {
    this.$emit('chart-created', this.filterObject);
  },
}
</script>

<style lang="scss" scoped>
.scroll-bar {
  position: 'absolute';
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>